// extracted by mini-css-extract-plugin
module.exports = {"labelColumn":"RequestHeader_labelColumn__3kfVh","nextToLabelColumn":"RequestHeader_nextToLabelColumn__32vut"};